import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { StyledSvgIcon, setSvgIconSize } from '../SvgIcon'
import { LABEL_HEIGHT } from './constants'
import Caption from 'LuxKit/Typography/Caption'
import clsx from 'clsx'

const _BaseLabelElement = styled.span`
  height: ${LABEL_HEIGHT};
  max-width: fit-content;
  padding: 0 ${rem(8)};
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  flex-wrap: nowrap;
  border: 1px solid transparent;
  border-radius: ${props => props.theme.borderRadius.S};
  gap: ${rem(4)};

  > ${StyledSvgIcon} {
    ${setSvgIconSize(16)}
  }

  &.iconOnly {
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${LABEL_HEIGHT};
    width: ${LABEL_HEIGHT};
    max-width: unset;
    border-radius: ${props => props.theme.borderRadius.round};
    padding: 0;
  }
`

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
  format?: React.ComponentProps<typeof Caption>['format']
}

/**
 * This is a base 'abstract' label that is used by all the *implementation labels*
 * This should never be used directly. Talk to your designer to discover the correct
 * label type to use in the event you are unsure.
 */
function _BaseLabel(props: Props) {
  const {
    startIcon,
    endIcon,
    children,
    className,
    format,
    ...rest
  } = props

  const iconOnly = !!startIcon && !children

  return <_BaseLabelElement
    {...rest}
    className={clsx(className, { iconOnly })}
  >
    {startIcon}
    {!iconOnly && <>
      <Caption variant="medium" weight="bold" format={format}>{children}</Caption>
      {endIcon}
    </>}
  </_BaseLabelElement>
}

export default _BaseLabel
